import { Box, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 725,
  maxHeight: "90vh",
  display: "flex",
  flexDirection: "column",
  background: theme.palette.custom.virtualSuccess,
  borderRadius: theme.borderRadius.radius.regular,
  color: theme.palette.custom.white,
  outline: "none",
  overflow: "hidden",
  [theme.breakpoints.down("md")]: {
    width: 430,
  },
  [theme.breakpoints.down("sm")]: {
    width: 350,
  },
  [theme.breakpoints.down("xs")]: {
    width: 270,
  },
}));

export const ModalHeader = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
}));
export const StyledBoxFlexGap = styled(Box)(() => ({
  display: "flex",
  gap: "8px",
  alignItems:"center" //Rishabh : To align icon in center
}));

export const StyledImg = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  paddingTop: "16px",
  paddingRight: "25px",
}));
export const StyledBoxImg = styled(Box)(() => ({
  flex: 1,
  overflowY: "auto",
  padding: "22px",
}));
export const StyledBoxGap = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "10px 16px",
  background: theme.palette.custom.chatGroupBg,
  border: "1px solid #ABD4FB",
  marginTop: "20px",
  borderRadius: theme.borderRadius.radius.wallet,
}));
export const StyledBoxCart = styled(Box)(({ theme }) => ({
  padding: "10px 16px",
  background: theme.palette.custom.chatGroupDesBg,
  border: "1px solid #FFD9AF",
  marginTop: "18px",
  borderRadius: theme.borderRadius.radius.wallet,
}));

export const StyledBoxValue = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.white,
  color: theme.palette.custom.profileSuccess,
  fontSize: theme.typography.regular.fontSize,
  marginTop: "10px",
  padding: "10px  14px",
}));
export const StyledBoxTextFlex = styled(Box)(({ theme }) => ({
  display: "flex",
  padding: "24px",
  gap: "60px",
  [theme.breakpoints.down("sm")]: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
}));
export const StyledBoxRap = styled(Box)(() => ({
  flex: 1,
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.large.fontSize,
  fontWeight: theme.typography.fontWeight.semiBold,
  color: theme.palette.custom.shopperAssignedColor,
  marginTop: "26px",

  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.regular.fontSize,
  },
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const ModalDescription = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  fontSize: theme.typography.base.fontSize,
  color: theme.palette.custom.shopperAssignedDesColor,
  marginTop: "6px",
  [theme.breakpoints.down("md")]: {
    fontSize: theme.typography.mini.fontSize,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: theme.typography.tiny.fontSize,
  },
}));
export const ButtonWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  padding: "16px 22px",
  borderTop: "1px solid #E5E7EB",
  background: "#fff",
  borderBottomLeftRadius: "12px",
  borderBottomRightRadius: "12px",
  flexShrink: 0,
}));
export const StyledSpan = styled("span")(({ theme }) => ({
  color: theme.palette.custom.primary,
}));
export const CloseBtn = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.blackColor,
  cursor: "pointer",
}));
export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  fontSize: theme.typography.small.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
}));
export const StyledTypographyGroup = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.startInputColor,
  fontSize: theme.typography.regular.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const StyledTypographyDes = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.startInputColor,
  fontSize: theme.typography.regular.fontSize,
  paddingLeft: "25px",
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const StyledBoxCard = styled(Box)(({ theme }) => ({
  background: theme.palette.custom.primary,
  display: "flex",
  padding: "13px 25px",
  borderTopRightRadius: theme.borderRadius.radius.large,
  borderTopLeftRadius: theme.borderRadius.radius.large,
}));
export const StyledBoxFlex = styled(Box)(() => ({
  display: "flex",
  gap: "2px",
  width: "100%",
  alignItems: "center",
}));
